import { render, staticRenderFns } from "./OwnerIdeaSelectModalContent.vue?vue&type=template&id=48021702&scoped=true&"
import script from "./OwnerIdeaSelectModalContent.vue?vue&type=script&lang=ts&"
export * from "./OwnerIdeaSelectModalContent.vue?vue&type=script&lang=ts&"
import style0 from "./OwnerIdeaSelectModalContent.vue?vue&type=style&index=0&id=48021702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48021702",
  null
  
)

export default component.exports